module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/desenrola2x-047d612b12ce96e5e5624ef4f82e6631.png";